<template>
  <div class="div-top-box" :style="`height:${height}`">
    <div class="div-top" :style="
	[
    top?{top:top}:'',
		radius?{borderRadius:radius}:'',
		bg?{background:bg}:'',
		padding?{padding:padding}:'',
		shadow?{boxShadow:'0px 1vw 3vw '+shadow}:'',
	]" :class="{tabBar}">
      <slot></slot>

    </div>
  </div>
</template>
<script>
export default {
  name: "div-foot",
  props: {
    top: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "12vw",
    },
    shadow: {
      type: [String, Boolean],
      default: false,
    },
    radius: {
      type: String,
      default: "0",
    },
    padding: {
      type: String,
      default: "0vw",
    },
    bg: {
      type: String,
      default: "transparent",
    },
    tabBar: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang='less' scoped>
.div-top {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  // padding: 0 30rpx;
  // padding-bottom: constant(safe-area-inset-bottom);
  // padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
  z-index: 10;
}
</style>
